import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import configureStore from './configureStore';

const { store } = configureStore();

const withStore = <P extends PropsWithChildren<unknown>>(Component: React.FC<P>) => (props: P): JSX.Element => (
  <Provider store={store}>
    <Component {...props} />
  </Provider>
);

export const globalStore = store;

export default withStore;
